import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import redPin from './assets/reddot.png';
import greenPin from './assets/greendot.png';
import blueCircle from './assets/bluedot.png';

// Fix: Define Leaflet Icons Correctly
const redIcon = new L.Icon({
  iconUrl: redPin,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
  className: 'custom-red-icon'
});

const greenIcon = new L.Icon({
  iconUrl: greenPin,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
  className: 'custom-green-icon'
});

const blueIcon = new L.Icon({
  iconUrl: blueCircle,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
  className: 'custom-blue-icon'
});

// Custom hook to track user location (GPS)
function useUserLocation() {
  const [userLocation, setUserLocation] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => console.error('Geolocation error:', error),
        { enableHighAccuracy: true, timeout: 10000 }
      );
    }
  }, []);

  return userLocation;
}

function App() {
  const [deliveryPoints, setDeliveryPoints] = useState([]);
  const userLocation = useUserLocation();
  const API_URL = 'https://metabuilds-yzbd.vercel.app/deliveries';

  const fetchPoints = async () => {
    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error("Failed to load delivery points.");
      const data = await res.json();
      setDeliveryPoints(data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchPoints();
  }, []);

  const addPoint = async (latlng) => {
  const name = prompt('Enter a name for this point:');
  if (!name) return;

  try {
    const res = await fetch('https://metabuilds-yzbd.vercel.app/deliveries', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...latlng, name })
    });

    if (!res.ok) {
      console.error("Failed to add delivery point:", res.statusText);
      alert("Failed to add delivery point.");
      return;
    }

    const newPoint = await res.json();
    setDeliveryPoints((prevPoints) => [...prevPoints, newPoint]);
  } catch (error) {
    console.error("Add Point Error:", error);
    alert("Failed to add delivery point.");
  }
};
/*
  const removePoint = async (id) => {
    const confirmDelete = window.confirm("Delete this delivery point?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE'
      });
      if (!res.ok) throw new Error("Failed to delete delivery point.");
      fetchPoints();
    } catch (error) {
      console.error("Delete Point Error:", error);
      alert("Failed to delete delivery point.");
    }
  };
  */

  function LocationMarker({ onMapClick }) {
    useMapEvents({
      click(e) {
        onMapClick(e.latlng);
      },
    });
    return null;
  }

  return (
    <div>
      <h2>Admin Panel</h2>
      <MapContainer 
        center={[60.1000, 19.9333]} 
        zoom={13} 
        style={{ height: '600px', width: '100%' }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <LocationMarker onMapClick={addPoint} />

        {userLocation && (
          <Marker position={[userLocation.lat, userLocation.lng]} icon={blueIcon}>
            <Popup>You are here</Popup>
          </Marker>
        )}

        {deliveryPoints.map((point) => (
          <Marker
            key={point.id}
            position={[point.lat, point.lng]}
            icon={point.status === 'completed' ? greenIcon : redIcon}
          >
            <Popup>
              <strong>{point.name}</strong><br />
              Status: {point.status}
               <button onClick={() => /*removePoint(point.id)*/console.log("hello")} style={{ color: 'red', marginTop: '5px' }}>🗑️ Delete Point</button>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}

export default App;
